import { toggleCart, showCart } from '../cart/cart.js';

// Adjust the 'top' position based on nav-main height
const navMain = document.querySelector('.nav-main');
const navExtended = document.querySelector('.nav-extended');

document.querySelectorAll('.nav-main__cart-toggle').forEach(function(btn) {
  btn.addEventListener('click', function() {
    toggleCart();
  });
});

document.querySelectorAll('.nav-main__right__toggles__cart').forEach(function(btn) {
  btn.addEventListener('click', function() {
    toggleCart();
  });
});




if (navMain && navExtended) {

  // Open and close the menu
  document.querySelectorAll('.nav-main__extended-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelector('.nav-extended').classList.toggle('is-open');
      document.querySelectorAll('.nav-main__extended-toggle__icon__line').forEach(function(line) {
        line.classList.toggle('is-open');
      });
      document.querySelectorAll('.nav-main__extended-toggle').forEach(function(toggle) {
        toggle.classList.toggle('is-open');
      });
      document.querySelectorAll('.nav-main').forEach(function(toggle) {
        toggle.classList.toggle('extended-open');
      });
      closeCart();
    });
  });

}

document.querySelectorAll('.nav-main__right__toggles__search').forEach(function(btn) {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.nav-main__search').forEach(function(search) {
      search.classList.toggle('visible');
    });
    var field = btn.closest('.nav-main').querySelector('.search-form__field');
    if (field) field.focus();
  });
});

document.addEventListener('click', (event) => {
  if (event.target.matches('.cart-toggle')) {
    event.preventDefault();
    showCart();
  }
});